<!-- Filter Button In Mobile -->
<div class="filter-sorting" (click)="openFilterDialog()">
  <i class="fa fa-sliders"></i>&nbsp;&nbsp; Filters By
</div>

<!-- Modal Overlay -->
<div class="modal-overlay"></div>

<!-- Filter Modal Content -->
<div class="filter-content-mobile" *ngIf="showResult">
  <div class="header-mob-filter">
    <button class="close-modal" (click)="closeFilterDialog()">&larr;</button>
    <h1>Filters</h1>
    <button class="reset">Reset All</button>
  </div>

  <div class="filters-mob-filter">

    <div class="filter-option">
      <div class="filter-option-mob-filter" (click)="MobFilterAction('price');">
        <div>Price Range ({{CompanySetting.CurrencySymbols}})</div>
        <span><i id="pricemi" class="fas fa-angle-right"></i></span>
      </div>
      <div id="pricems" class="price-range show">
        <ng5-slider [(value)]="minMaxValues.priceMinValue" [(highValue)]="minMaxValues.priceMaxValue"
                    [options]="priceOptions" (userChangeEnd)="PriceChange()">
        </ng5-slider>
      </div>
    </div>
    <div class="filter-option">
      <div class="filter-option-mob-filter" (click)="MobFilterAction('hname');">
        <div>Hotel Name</div>
        <span><i id="hnamemi" class="fas fa-angle-right"></i></span>
      </div>
      <div id="hnamems" class="price-range">
        <input [(ngModel)]="HotelName" (keyup)="ApplyFilter();" autocomplete="disabled" placeholder="Search by Hotel Name" class="form-control" name="hotelName">
        <i *ngIf="!isHotelName" class="fa fa-search search-h-icon"></i>
        <i *ngIf="isHotelName" class="fas fa-times clear-h" (click)="ClearHotel()"></i>
        <ng-template #hotelSearchTemplate let-model="item" let-index="index">
          <div class=" fxLayout" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="0">
            <div class="item item-1" fxFlex="10%">
              <i class="fas fa-hotel" style="color: #E1E1E1;font-size: 16px;"></i>
            </div>
            <div class="item item-1" fxFlex="90%">
              <div class="SearchAirportcity">
                {{ model }}
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="filter-option">
      <div class="filter-option-mob-filter" (click)="MobFilterAction('popular');">
        <div>Popular</div>
        <span><i id="popularmi" class="fas fa-angle-right"></i></span>
      </div>
      <div class="price-range" id="popularms">
        <div class="new-mb-fr-filter-container">
          <div class="new-mb-fr-filter-item">
            <input type="checkbox" class="custom-control-input" id="customCheck-Free-Cancellation" name="custm"
                   (click)="IsFreeCancellation=!IsFreeCancellation;ApplyFilter();">
            <label class="custom-control-label" for="customCheck-Free-Cancellation">Free Cancellation </label>
          </div>
          <div class="new-mb-fr-filter-item">
            <input type="checkbox" class="custom-control-input" id="customCheck-offer" name="custm"
                   (click)="IsRecommendedHotel=!IsRecommendedHotel;isStarLowToHigh=null;isStarHighToLow=null;
            isPriceLowToHigh=null;isPriceHighToLow=null;ApplyFilter();">
            <label class="custom-control-label" for="customCheck-offer">Offer</label>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-option">
      <div class="filter-option-mob-filter" (click)="MobFilterAction('star');">
        <div>Star Rating</div>
        <span><i id="starmi" class="fas fa-angle-right"></i></span>
      </div>
      <div class="price-range" id="starms">
        <div class="new-mb-fr-filter-container">
          <div class="new-mb-fr-filter-item">
            <input type="checkbox" class="custom-control-input" id="customCheck-1" name="custm" (click)="StarChange(4)">
            <label class="custom-control-label" for="customCheck-1">5 Star ({{HotelFilterModel.Ratings[4].count}})</label>
          </div>
          <div class="new-mb-fr-filter-item">
            <input type="checkbox" class="custom-control-input" id="customCheck-2" name="custm" (click)="StarChange(3)">
            <label class="custom-control-label" for="customCheck-2">4 Star ({{HotelFilterModel.Ratings[3].count}})</label>
          </div>
          <div class="new-mb-fr-filter-item">
            <input type="checkbox" class="custom-control-input" id="customCheck-3" name="custm" (click)="StarChange(2)">
            <label class="custom-control-label" for="customCheck-3">3 Star ({{HotelFilterModel.Ratings[2].count}})</label>
          </div>
          <div class="new-mb-fr-filter-item">
            <input type="checkbox" class="custom-control-input" id="customCheck-4" name="custm" (click)="StarChange(1)">
            <label class="custom-control-label" for="customCheck-4">2 Star ({{HotelFilterModel.Ratings[1].count}})</label>
          </div>
          <div class="new-mb-fr-filter-item">
            <input type="checkbox" class="custom-control-input" id="customCheck-5" name="custm" (click)="StarChange(0)">
            <label class="custom-control-label" for="customCheck-5">1 Star ({{HotelFilterModel.Ratings[0].count}})</label>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-option" style="max-height: 200px; overflow-y: scroll;"
         *ngIf="HotelFilterModel.Inclusions !=null && HotelFilterModel.Inclusions.length>0">
      <div class="filter-option-mob-filter" (click)="MobFilterAction('inclusion');">
        <div>Inclusions</div>
        <span><i id="inclusionmi" class="fas fa-angle-right"></i></span>
      </div>
      <div class="price-range" id="inclusionms">
        <div class="new-mb-fr-filter-container">
          <div class="new-mb-fr-filter-item" *ngFor="let inc of HotelFilterModel.Inclusions;let i=index;">
            <input type="checkbox" class="custom-control-input" id="customCheckp_inc_{{i}}" [(ngModel)]="inc.value" (change)="ApplyFilter();" name="custm">
            <label class="custom-control-label" for="customCheckp_inc_{{i}}">{{inc.name}}</label>
          </div>
        </div>
      </div>
    </div>
    <!-- Apply Button -->
    <div class="app-btn">
      <button class="apply-button" (click)="closeFilterDialog()">Apply</button>
    </div>

  </div>
</div>

<section>
  <div class="container searchbar waitingmsg" *ngIf="hotelSuppliers!=null? hitcount != hotelSuppliers.length:hotelSuppliers" >
    <div class="row">
      <div class="col-sm-12">
        <h4>Getting the best deals from top hotels...</h4>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>

      </div>
    </div>
  </div>
  <div class="loader-hotel" *ngIf="!showResult && !noResultFound">
    <app-hotellistloader></app-hotellistloader>
  </div>

</section>
<!--Waiting Srceen End-->
<!-- Modify Filters section -->
<div class="modify-search-modal" id="modifySearchModal">
  <div class="header-mob-filter">
    <button class="close-modal desk-hide" (click)="ClosemodifySearchDialog()">&larr;</button>
    <h1>Modify Search</h1>
    <button class="reset modifyCross desk-hide" (click)="ClosemodifySearchDialog()">X</button>
  </div>
  <div class="container">
    <div class="search-content">
      <form (ngSubmit)="ModifyResult(searchForm.form.valid)" #searchForm="ngForm" novalidate id="hsearchForm">
        <div class="row mb-3 search-frm">
          <div class="col-4F search-frm-bx">
            <label for="leavingFrom" class="form-label filter-title">Destination or Hotel name</label>
            <img class="locationicon" src="./assets/images/Icon/placeholder.png">
            <input [(ngModel)]="DestinationCity" [typeahead]="hotelResulList"
                   class="form-control padding-left-text-frm ui-autocomplete-input"
                   name="hotelFromCity" (click)="$event.target.select()" #hotelFromCity="ngModel"
                   (typeaheadOnSelect)="formatHotelCity($event)"
                   autocomplete="off" [typeaheadItemTemplate]="hotelSearchTemplate"
                   placeholder="Destination or Hotel name" titles="3 charecters minimum" type="text"
                   [ngClass]="{'is-invalid': searchForm.submitted && hotelFromCity.invalid || !fromCityValid}" required>
            <ng-template #hotelSearchTemplate let-model="item" let-index="index">
              <div class="">
                <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
                {{ model.CityName }} ({{model.CityCode}}), <span>
                  {{model.CountryName}}
                </span>
              </div>
            </ng-template>
          </div>

          <div class="col-2 search-frm-bx">
            <label for="departureDate" class="form-label filter-title">Check-In</label>
            <div class="input-group sf clander-a" (click)="checkin.show()">
              <input name="checkINDate" placeholder="DD/MM/YYYY" type="text"
                     style="position: absolute; z-index: -1;" value=""
                     class="form-control" id="drpDepartDate" #fromDate="bsDatepicker"
                     bsDatepicker [outsideClick]="true" #checkin="bsDatepicker"
                     [(ngModel)]="HotelSearchModel.Request.Master.CheckIn"
                     [bsConfig]="{ adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD' }"
                     (bsValueChange)="HotelFromDateChange($event);" [minDate]="minDate"
                     [maxDate]="fromMax">
              <span class="form-control calr">
                {{HotelSearchModel.Request.Master.CheckIn | date:'dd-MMM-yyyy'}}
              </span>
            </div>
          </div>
          <div class="col-2 search-frm-bx">
            <label for="returnDate" class="form-label filter-title">Check-Out</label>
            <!--Return date-1-->
            <div class="input-group sf clander-a" (click)="checkout.show()">
              <input name="checkOutDate" placeholder="DD/MM/YYYY" type="text"
                     style="position: absolute; z-index: -1;" value=""
                     class="form-control" id="drpDepartDate"
                     bsDatepicker [outsideClick]="true"
                     [(ngModel)]="HotelSearchModel.Request.Master.CheckOut" #checkout="bsDatepicker"
                     [bsConfig]="{ adaptivePosition: true,dateInputFormat: 'YYYY-MM-DD' }"
                     [minDate]="minCheckoutDate">
              <span class="form-control calr">
                {{HotelSearchModel.Request.Master.CheckOut | date:'dd-MMM-yyyy'}}
              </span>
            </div>
          </div>

          <div class="col-3F search-frm-bx dro-trv-main ">
            <label class="form-label filter-title">Room & Guests</label>
            <button type='button' class="custom-select height40 pad-left-25 txt-radius borderguest">
              {{HotelSearchModel.Request.RequestDetails.Search.Rooms.Room.length}} Rooms {{GuestCount}} Guest
            </button>
            <div id="drop-trv" class="drop-trv">
              <div *ngFor="let room of HotelSearchModel.Request.RequestDetails.Search.Rooms.Room;let i=index;">
                <div class="rm-txt">
                  Room {{i+1}} :
                </div>
                <div class="left-box">
                  <span class="txt">
                    <span id="txt-innr">Adult <em>(Above 12 years)</em></span>
                  </span>
                </div>
                <div class="right-box">
                  <div class="pls-mns-row">
                    <a type="button" id="adt-min" class="sub" *ngIf="room.Adult>1"
                       (click)="DecreaseGuest('A',i)">-</a>
                    <span id="adlt-nbr" class="adlt-number">
                      {{room.Adult}}
                    </span>
                    <a type="button" id="adt-plus" class="plus" *ngIf="room.Adult<4"
                       (click)="IncreaseGuest('A',i)">+</a>
                  </div>
                </div>
                <div class="space-rw">
                </div>
                <div class="left-box">
                  <span class="txt">
                    <span id="txt-innr">Child <em>(Below 12 years)</em></span>
                  </span>
                </div>
                <div class="right-box">
                  <div class="pls-mns-row">
                    <a type="button" id="adt-min" class="sub" *ngIf="room.Child>0"
                       (click)="DecreaseGuest('C',i)">-</a>
                    <span id="adlt-nbr" class="adlt-number">
                      {{room.Child}}
                    </span>
                    <a type="button" id="adt-plus" class="plus" *ngIf="room.Child<4"
                       (click)="IncreaseGuest('C',i)">+</a>
                  </div>
                </div>

                <div class="space-rw">
                </div>

              </div>
              <div class="clear"></div>
              <a class="add-room"
                 *ngIf="HotelSearchModel.Request.RequestDetails.Search.Rooms.Room.length<5"
                 (click)="AddRoom()">
                Add Room
              </a>
              <a class="add-room"
                 *ngIf="HotelSearchModel.Request.RequestDetails.Search.Rooms.Room.length>1"
                 (click)="RemoveRoom()">
                Remove Room
              </a>
              <a href="javascript:void(0)" (click)="hidepaxdiv()" class="done-btn">
                Done
              </a>
            </div>
          </div>
          <div class="col-1F d-flex align-items-end srh-flt">
            <button type="submit" href="javascript:void(0)" data-hover="SEARCH NOW" (click)="myFormSubmitHandler()" class="modifysBtn"></button>
          </div>
          <div class="close-mdfs" (click)="ClosemodifySearchDialog()">
            <button type="button" class=""><i class="fa fa-close"></i></button>
          </div>
        </div>
      </form>
    </div>

  </div>

</div>
<div id="overlay" class="overlay-modal" (click)="ClosemodifySearchDialog()"></div>
<!-- End Of Modify filter section -->
<!-- Filter, modify and share header for mobile view -->
<div class="mobile-view-header">
  <i class="fas fa-arrow-left back-icon" onclick="redirectToHome()"></i>
  <div class="route-details">
    <span class="route">{{SearchKeyword}}</span>
    <span class="sub-details">{{checkInDate | date :'dd MMM yy'}} To {{checkOutDate | date :'dd MMM yy'}} | {{roomCount}} Room(s), {{GuestCount}} Guest(s)</span>
  </div>
  <div class="action-icons">
    <a href="javascript:void(0);" (click)="OpenmodifySearchDialog()">
      <i class="fas fa-edit action-icon"></i>
    </a>
  </div>
</div>
<!--End Of Filter, modify and share header for mobile view -->
<!--result-box-->

<div class="container padding-b30">
  <div class=" result-serach">
    <div class="row">
      <div class="col-7">
        <div class="mdf-sc-flight-card">
          <div class="mdf-sc-flight-info">
            <h6>{{SearchKeyword}}</h6>
            <small>{{roomCount}} Room(s), {{GuestCount}} Guest(s)</small>
          </div>
          <div class="mdf-sc-flight-dates">
            <div class="mdf-sc-date-item">
              <p>
                {{checkInDate | date :'dd MMM yy'}}
              </p>
              <span>{{checkInDate | date :'EEEE'}}</span>
            </div>
            <div class="flt-2"><i class="fa-solid fa-minus"></i></div>
            <div class="mdf-sc-date-item">
              <p>
                {{checkOutDate| date :'dd MMM yy'}}
              </p>
              <span>{{checkOutDate| date :'EEEE'}}</span>
            </div>
          </div>
          <div class="mdf-sc-edit-icon" (click)="OpenmodifySearchDialog()" style="cursor: pointer;">
            <i class="fas fa-pen"></i>
          </div>

        </div>
      </div>

      <div class="col-5">
        <div class="d-flex align-items-center new-sorts">
          <span class="me-2">Sort&nbsp;By:&nbsp;&nbsp;</span>
          <select name="holidaytype" class="custom-select height40 pad-left-25"
                [(ngModel)]="sortByData" (change)="ApplyFilter();">
            <option value="priceltoh">Price (Low To High)</option>
            <option value="pricehtol">Price (High To Low)</option>
            <option value="starltoh">Star (Low To High)</option>
            <option value="starhtol">Star (High To Low)</option>
            <option value="">Recommended</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="row margi-tp" *ngIf="showResult">
    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12 search-page-main mobile-dp-none">
      <div class=" filter-section ttl-container d-flex justify-content-between">
        <h2 class="totalresult" id="total-av-flights">
          Total Available Hotels :
        </h2>
        <h2 class="totalresult">
          ( {{ResultData.Response.ResponseDetails.Search.Hotels.Total}} )
        </h2>
      </div>

      <div class="filter-box-main sticky-top">
        <div class="filter-box">
          <div class="box-inner">
            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
              <div class="panel panel-default">
                <div class="panel-heading" role="tab" id="headingdhname">
                  <h4 class="panel-title">
                    <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapsedhname" aria-expanded="true" aria-controls="collapsedhname">
                      <i class="fa fa-hand-paper-o" aria-hidden="true"></i>
                      Hotel Name
                    </a>
                  </h4>
                </div>
                <div id="collapsedhname" class="panel-collapse collapse in show" role="tabpanel" aria-labelledby="headingdhname">
                  <div class="panel-body">
                    <input [(ngModel)]="HotelName" (keyup)="ApplyFilter();" autocomplete="disabled" placeholder="Search by Hotel Name" class="form-control" name="hotelName">
                    <i *ngIf="!isHotelName" class="fa fa-search search-h-icon"></i>
                    <i *ngIf="isHotelName" class="fas fa-times clear-h" (click)="ClearHotel()"></i>
                    <ng-template #hotelSearchTemplate let-model="item" let-index="index">
                      <div class=" fxLayout" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="0">
                        <div class="item item-1" fxFlex="10%">
                          <i class="fas fa-hotel" style="color: #E1E1E1;font-size: 16px;"></i>
                        </div>
                        <div class="item item-1" fxFlex="90%">
                          <div class="SearchAirportcity">
                            {{ model }}
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-box">
          <div class="box-inner">
            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
              <div class="panel panel-default">
                <div class="panel-heading" role="tab" id="filterdprice">
                  <h4 class="panel-title">
                    <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapsedprice" aria-expanded="true" aria-controls="collapsedprice">
                      {{CompanySetting.CurrencySymbols}} Price Range
                    </a>
                  </h4>
                </div>
                <div id="collapsedprice" class="panel-collapse collapse in show" role="tabpanel" aria-labelledby="filterdprice">
                  <div class="panel-body">
                    <ng5-slider [(value)]="minMaxValues.priceMinValue" [(highValue)]="minMaxValues.priceMaxValue"
                                [options]="priceOptions" (userChangeEnd)="PriceChange()">
                    </ng5-slider>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>

        <div class="filter-box">
          <div class="box-inner">
            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
              <div class="panel panel-default">
                <div class="panel-heading" role="tab" id="fliterdrating">
                  <h4 class="panel-title">
                    <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapsedrating" aria-expanded="true" aria-controls="collapsedrating">
                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                      Star Rating
                    </a>
                  </h4>
                </div>
                <div id="collapsedrating" class="panel-collapse collapse in show" role="tabpanel" aria-labelledby="fliterdrating">
                  <div class="panel-body">
                    <div class="custom-control custom-checkbox my-1 mr-sm-2">
                      <input type="checkbox" class="custom-control-input" id="customCheck-1" name="custm" (click)="StarChange(4)">
                      <label class="custom-control-label" for="customCheck-1">5 Star ({{HotelFilterModel.Ratings[4].count}})</label>
                    </div>
                    <div class="custom-control custom-checkbox my-1 mr-sm-2">
                      <input type="checkbox" class="custom-control-input" id="customCheck-2" name="custm" (click)="StarChange(3)">
                      <label class="custom-control-label" for="customCheck-2">4 Star ({{HotelFilterModel.Ratings[3].count}})</label>
                    </div>
                    <div class="custom-control custom-checkbox my-1 mr-sm-2">
                      <input type="checkbox" class="custom-control-input" id="customCheck-3" name="custm" (click)="StarChange(2)">
                      <label class="custom-control-label" for="customCheck-3">3 Star ({{HotelFilterModel.Ratings[2].count}})</label>
                    </div>
                    <div class="custom-control custom-checkbox my-1 mr-sm-2">
                      <input type="checkbox" class="custom-control-input" id="customCheck-4" name="custm" (click)="StarChange(1)">
                      <label class="custom-control-label" for="customCheck-4">2 Star ({{HotelFilterModel.Ratings[1].count}})</label>
                    </div>
                    <div class="custom-control custom-checkbox my-1 mr-sm-2">
                      <input type="checkbox" class="custom-control-input" id="customCheck-5" name="custm" (click)="StarChange(0)">
                      <label class="custom-control-label" for="customCheck-5">1 Star ({{HotelFilterModel.Ratings[0].count}})</label>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>

        <div class="filter-box">
          <div class="box-inner">
            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
              <div class="panel panel-default">
                <div class="panel-heading" role="tab" id="hdpopular">
                  <h4 class="panel-title">
                    <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapsedpopular" aria-expanded="true" aria-controls="collapsedpopular">
                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                      Popular
                    </a>
                  </h4>
                </div>
                <div id="collapsedpopular" class="panel-collapse collapse in show" role="tabpanel" aria-labelledby="hdpopular">
                  <div class="panel-body">
                    <div class="custom-control custom-checkbox my-1 mr-sm-2">
                      <input type="checkbox" class="custom-control-input" id="customCheck-Free-Cancellation" name="custm"
                             (click)="IsFreeCancellation=!IsFreeCancellation;ApplyFilter();">
                      <label class="custom-control-label" for="customCheck-Free-Cancellation">Free Cancellation </label>
                    </div>
                    <div class="custom-control custom-checkbox my-1 mr-sm-2">
                      <input type="checkbox" class="custom-control-input" id="customCheck-offer" name="custm"
                             (click)="IsRecommendedHotel=!IsRecommendedHotel;isStarLowToHigh=null;isStarHighToLow=null;
          isPriceLowToHigh=null;isPriceHighToLow=null;ApplyFilter();">
                      <label class="custom-control-label" for="customCheck-offer">Offer</label>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
        <div class="filter-box" style="max-height: 200px; overflow-y: scroll;"
             *ngIf="HotelFilterModel.Inclusions !=null && HotelFilterModel.Inclusions.length>0">
          <div class="box-inner">
            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
              <div class="panel panel-default">
                <div class="panel-heading" role="tab" id="hdinclusion">
                  <h4 class="panel-title">
                    <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapsedinclusion" aria-expanded="true" aria-controls="collapsedinclusion">
                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                      Inclusions
                    </a>
                  </h4>
                </div>
                <div id="collapsedinclusion" class="panel-collapse collapse in show" role="tabpanel" aria-labelledby="hdinclusion">
                  <div class="panel-body">
                    <div class="custom-control custom-checkbox my-1 mr-sm-2" *ngFor="let inc of HotelFilterModel.Inclusions;let i=index;">
                      <input type="checkbox" class="custom-control-input" id="customCheckp_inc_{{i}}" [(ngModel)]="inc.value" (change)="ApplyFilter();" name="custm">
                      <label class="custom-control-label" for="customCheckp_inc_{{i}}">{{inc.name}}</label>
                    </div>

                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-9 col-md-9 col-sm-8 col-xs-12 pd-l-none my-cls">

      <div class="loader-hotel error-four-main" *ngIf="noResultFound">
        <div class="res-no-data">
          <div class="four-img">
            <img src="assets/images/no-result-img.png" alt="No Result Found." />
          </div>
          <div class="four-page-not">
            <span>Oops !</span> No Result Found
          </div>
          <div class="nf-details">
            We could not find any result as per your search criteria.

          </div>
          <div class="nf-details1">
            Please update your search criteria and do the search again.
          </div>
          <div class="src-again" style="padding-bottom:20px;">
            <button type="submit" class="slt-hotel radius-20" (click)="myFormSubmitHandler()">
              Search Again
            </button>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="showResult">

        

          <div class="result-item" *ngFor="let hotel of FilteredHotels | slice:0:showMoreCount ;let j=index;">
            <div class="hotel-box">
              <!-- Hotel Image Section -->
              <div class="hotel-image">
                <div class="mrel">
                  <div *ngIf="hotel.Offer=='Y'" class="htl_offer"><img src="/assets/images/HTLoffer.png"></div>
                  <div *ngIf="hotel.Refundablenfo != null && hotel.Refundablenfo != '' " class="Overlay__TopLeft HeroImage__CombinedBadgeContainer">
                    <div class="sc-bdfBwQ gNRfUM sc-JAcuL eKGqnO DefaultBadge DefaultBadge--OptionIncluded">
                      <div>
                        <span>{{hotel.Refundablenfo}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="top_deal posab_dd"><span>DEAL OF THE DAY</span></div>
                  <div class="big_img">
                    <div>
                      <img id="imgm{{j}}" *ngIf="hotel.Image != '' && hotel.Image != null" [src]="hotel.Image"
                           onError="this.src='/assets/images/hotel/not_avil.jpg'" class="listImage" width="332"
                           style="background-image: url(assets/images/image-1.jpg); background-size: 100%;">
                    </div>
                  </div>
                  <div class="imgcolmns">
                    <span class="inrimgsec">
                      <img src="assets/images/image-1.jpg" alt="Img" (mouseover)="onMouseOver('assets/images/image-1.jpg',j)">
                    </span><span class="inrimgsec">
                      <img src="assets/images/image-2.jpg" alt="Img" (mouseover)="onMouseOver('assets/images/image-2.jpg',j)">
                    </span><span class="inrimgsec">
                      <img src="assets/images/image-3.jpg" alt="Img" (mouseover)="onMouseOver('assets/images/image-3.jpg',j)">
                    </span>
                    <span class="inrimgsec font-bold">
                      <img src="assets/images/image-4.jpg" class="viewall" alt="Img">
                      <span class="vwallimg"><a class="showpointer" (click)="GetHotelRoom(hotel.HotelId,hotel.Token,hotel.Provider,hotel.Star)"><i class="far fa-images"></i><br />View All</a></span>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Hotel Info Section -->
              <div class="content-dtl">
                <h5 class="fw-bold mb-1">
                  {{hotel.Name}}
                </h5><span class="str-rw">
                  <i *ngFor="let star of ' '.repeat(hotel.Star).split('')" class="fas fa-star"></i>
                </span> <span *ngIf="!IsProdution">--Provider-{{hotel.Provider}} </span>
                <div class="address">
                  <p class="text-muted mb-1">
                    <i class="fa fa-map-marker"></i>&nbsp;{{hotel.DisplayAdd}}
                  </p>
                </div>
                <div *ngIf="hotel.SupCode=='TBO' && hotel.Desc !=null  && hotel.Desc !=''" class="addrs">
                  <i class="fas fa-info-circle"></i>
                  <span>
                    {{hotel.Desc.length>145? (hotel.Desc | slice:0:143)+' ..' : hotel.Desc}}
                  </span>
                </div>
                <div class="high_lt">
                  <p class="mb-2">
                    <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>Free Cancellation</span>
                    <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>Free Wi-Fi</span>
                    <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>free wi-Fi</span>
                    <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>free wi-Fi</span>
                    <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>free wi-Fi</span>
                    <span class="text-success inclusionchk"><i class="fa-solid fa-check-double"></i>24 Hour Room Service</span><br />
                  </p>
                </div>
                <div class="high_lt" *ngIf="hotel.Inclusions !=null && hotel.Inclusions.length>0">
                  <p class="mb-2">
                    <span class="text-success inclusionchk" *ngFor="let inc of hotel.Inclusions.slice(0,3)"><i class="fa-solid fa-check-double"></i>{{inc}}</span><br />
                  </p>
                </div>
              </div>
              <!--extra info-->

              <div class="price-dtl">
                <div class="rate-col">
                  <div class="Review-Section-item">
                    <div class="Review-Section-scoreText">
                      <span class="Review-Section-scoreText">Excellent</span>
                    </div>
                    <div class="Review-Section-count">
                      <span>1752</span>
                      <span> reviews</span>
                    </div>
                  </div>
                  <div class="review-bg-g">5.0</div>
                </div>
                <!--here amt-->
                <div class="prntax">
                  <div class="cross_price"><span class="CurrncyCD_INR"></span><span>{{sharedServiceService.currencySymbol}}{{((hotel.MinPrice)+(hotel.MinPrice*8/100))*(sharedServiceService.currencyConversionRate) | number:'1.2-2'}}</span></div>
                  <div class="act_price"><span class="CurrncyCD_INR"></span><span> {{sharedServiceService.currencySymbol}}{{(hotel.MinPrice)*(sharedServiceService.currencyConversionRate) | number:'1.2-2'}}</span></div>
                  <div class="prn">Per Night</div>
                </div>

                <div class="htbtn">
                  <button type="submit" class="slt-hotel viewBtn" (click)="GetHotelRoom(hotel.HotelId,hotel.Token,hotel.Provider,hotel.Star)">
                    View Room
                  </button>
                </div>
              </div>

            </div>


          </div>
          <div class="container" *ngIf="showResult">
            <div class="row">
              <div class="col-lg-12 text-center" *ngIf="FilteredHotels.length>showMoreCount">
                <button class="slt-hotel" (click)="showMoreCount=showMoreCount+50">Show More</button>
              </div>
            </div>
          </div>

          <!--no-filter-result-->
          <div class="loader-hotel" *ngIf="FilteredHotels.length==0" style="width: 75% !important;">
            <div class="res-no-data error-four-main">
              <div class="four-img">
                <img src="assets/images/filter-no-result.png" alt="No Result Found." />
              </div>
              <div class="four-page-not">
                <span>Oops !</span> No Result Found
              </div>
              <div class="nf-details">
                We could not find any result as per your filter criteria.

              </div>
              <div class="nf-details1">
                Try a different combination of filters.
              </div>
              <div class="src-again" style="padding-bottom:20px;">
              </div>
            </div>
          </div>
          <!--no-filter-result end-->
        </div>
      </div>
    </div>
  </div>
